<template>
  <el-dialog
    :visible.sync="dialogVisible"
    width="900px"
    :title="$t('ShoppingCartDialog.title')"
    custom-class="cart-dialog"
    append-to-body
    @close="handleClose"
  >
    <div class="cart-content" v-loading="loading">
      <div class="cart-left">
        <!-- 产品分组列表 -->
        <div
          v-for="(group, gIdx) in groupedCartItems"
          :key="gIdx"
          class="cart-group"
        >
          <div class="group-header">
            <el-checkbox
              v-model="group.checked"
              @change="toggleGroupCheck(gIdx)"
            >
              {{ group.familyCode }}
            </el-checkbox>
          </div>
          <div
            v-for="(item, idx) in group.items"
            :key="item.id"
            class="cart-item"
          >
            <el-checkbox
              v-model="item.checked"
              @change="updateGroupCheck(gIdx)"
            />
            <div class="item-icon">
              <img :src="productIcon(item.production?.icon)" alt="" srcset="" />
            </div>
            <div class="item-info">
              <div class="item-name">
                {{ item.production?.name || item.productname || "" }}
              </div>
            </div>
            <div class="item-duration">
              {{ $t("ShoppingCartDialog.purchaseDuration") }}：{{ item.duration
              }}{{ durationLabelMap(item.durationunion) }}
            </div>
            <div class="item-price">
              ¥{{ getPrice(item, item.durationunion) }}
            </div>
            <div class="item-quantity">
              <el-button
                size="mini"
                icon="el-icon-minus"
                circle
                :disabled="item.number <= 1"
                @click="decreaseQty(item)"
              />
              <span>{{ item.number }}</span>
              <el-button
                size="mini"
                icon="el-icon-plus"
                circle
                @click="increaseQty(item)"
              />
            </div>
            <el-button
              type="text"
              class="delete-btn"
              :loading="item.deleting"
              @click="removeItem(gIdx, idx)"
            >
              {{ $t("ShoppingCartDialog.delete") }}
            </el-button>
          </div>
        </div>

        <!-- 空状态 -->
        <div v-if="!loading && cartItems.length === 0" class="empty-cart">
          <p>{{ $t("ShoppingCartDialog.emptyCart") }}</p>
        </div>
      </div>

      <!-- 右侧结算 -->
      <div class="cart-right">
        <div class="settle-card">
          <h3>{{ $t("ShoppingCartDialog.settlementDetails") }}</h3>
          <div v-if="selectedItems.length > 0" class="selected-icons">
            <span>{{
              $t("ShoppingCartDialog.totalProducts", {
                count: selectedItems.length,
              })
            }}</span>
            <div class="icons">
              <div
                v-for="item in selectedItems.slice(0, 4)"
                :key="item.id"
                class="mini-icon"
              >
                <img
                  :src="productIcon(item.production.icon)"
                  alt=""
                  srcset=""
                />
              </div>
            </div>
          </div>
          <div v-else class="empty-selected"></div>
          <div class="total-row">
            <span>{{ $t("ShoppingCartDialog.total") }}</span>
            <span class="total-price">¥{{ totalPrice }}</span>
          </div>
          <el-button
            type="primary"
            class="settle-btn"
            :disabled="selectedItems.length === 0"
            @click="handleSettle"
          >
            {{ $t("ShoppingCartDialog.settle") }}
          </el-button>
        </div>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import {
  C_cartList,
  setC_cartList,
  batchRemove,
  updataList,
} from "@/assets/API/cart";
import define from "@/utils/define";

const baseUrl = define.APIURl;

export default {
  name: "ShoppingCartDialog",

  props: {
    visible: Boolean,
    items: {
      type: Object,
      default: () => ({}),
    },
  },

  data() {
    return {
      dialogVisible: false,
      loading: false,
      cartItems: [],
    };
  },

  computed: {
    language() {
      return this.$i18n.locale;
    },

    groupedCartItems() {
      const groups = {};
      this.cartItems.forEach((item) => {
        const key = item.producttype || "SummitMap";
        item.durationunion = item.durationunion == "quarter" ? "season" : item.durationunion;
        if (!groups[key])
          groups[key] = { familyCode: key, checked: false, items: [] };
        groups[key].items.push(item);
      });
      Object.values(groups).forEach((g) => {
        g.checked = g.items.length > 0 && g.items.every((i) => i.checked);
      });
      return Object.values(groups);
    },

    selectedItems() {
      return this.cartItems.filter((i) => i.checked);
    },

    totalPrice() {
      let sum = 0;
      this.selectedItems.forEach((i) => {
        console.log("计算总价项", i, this.getPrice(i, i.durationunion));
        sum +=
          Number(this.getPrice(i, i.durationunion)) *
          Number(i.duration || 1) *
          Number(i.number || 1);
      });
      return sum.toFixed(2);
    },
  },

  watch: {
    visible: {
      immediate: true,
      handler(v) {
        if (v) {
          const userId = this.getCurrentUserId();
          if (!userId) {
            this.$message.warning("请先登录");
            this.dialogVisible = false;
            this.$emit("update:visible", false);
            return;
          }

          this.dialogVisible = true;
          this.cartItems.forEach((item) => {
            this.$set(item, "checked", false);
          });
          if (this.items && Object.keys(this.items).length > 0) {
            this.addToCart(this.items);
          } else {
            // 没有新商品，只加载购物车列表
            this.loadCartList();
          }

          // 弹框打开时加载购物车列表
          // this.loadCartList();
          return;
        }
        this.dialogVisible = false;
      },
    },
    dialogVisible(v) {
      this.$emit("update:visible", v);
    },
    items: {
      immediate: true,
      deep: true,
      handler(v) {
        if (!v || Object.keys(v).length === 0) return;
        // 有新商品传入时，调用加入购物车接口
      },
    },
  },

  methods: {
    getCurrentUserId() {
      try {
        const userInfo = JSON.parse(localStorage.getItem("USERINFO") || "{}");
        const userId = userInfo && userInfo.id;
        if (
          userId === undefined ||
          userId === null ||
          userId === "" ||
          userId === "undefined" ||
          userId === "null"
        ) {
          return "";
        }
        return String(userId);
      } catch (e) {
        return "";
      }
    },
    // ==================== 接口调用 ====================
    getPrice(item, durationUnit) {
      console.log("计算价格", item, durationUnit);

      const basePrice = durationUnit + "price";
      return item.pvData[basePrice] || 0;
    },
    productIcon(icon) {
      if (!icon) return null;

      // 已经是完整 URL（http/https 开头），直接返回
      if (/^https?:\/\//i.test(icon)) return icon;

      // 兼容已经是纯路径（如 /api/file/...）的情况
      if (typeof icon === "string" && icon.trim().startsWith("/")) {
        return `${baseUrl}${icon}`;
      }

      // 兼容旧数据：JSON 字符串格式 [{"url":"..."}]
      try {
        const pathJson = JSON.parse(icon);
        if (Array.isArray(pathJson) && pathJson[0] && pathJson[0].url) {
          const url = pathJson[0].url;
          return /^https?:\/\//i.test(url) ? url : `${baseUrl}${url}`;
        }
        if (pathJson && pathJson.url) {
          return /^https?:\/\//i.test(pathJson.url) ? pathJson.url : `${baseUrl}${pathJson.url}`;
        }
      } catch (e) {
        /* 非合法 JSON，返回原值兜底 */
      }
      return icon;
    },
    durationLabelMap(duration) {
      const map = {
        week: this.$t("ShoppingCartDialog.week"),
        month: this.$t("ShoppingCartDialog.month"),
        season: this.$t("ShoppingCartDialog.quarter"),
        halfyear: this.$t("ShoppingCartDialog.halfyear"),
      };
      return map[duration] || duration;
    },
    // 加载购物车列表
    async loadCartList() {
      this.loading = true;
      try {
        const userid = this.getCurrentUserId();

        if (!userid) {
          this.$message.warning("请先登录");
          this.cartItems = [];
          this.dialogVisible = false;
          return;
        }

        const res = await C_cartList({ userid });

        if (res.code === 200 && res.data) {
          // 将接口返回的数据转换为组件需要的格式
          this.cartItems = (res.data.list || []).map((item) => ({
            ...item,
            checked: false, // 默认不选中
          }));
        } else {
          if (res && (res.code === 401 || res.code === 403)) {
            this.$message.warning("请先登录");
            this.dialogVisible = false;
          }
          this.cartItems = [];
        }
      } catch (err) {
        console.error("加载购物车失败:", err);
        if (!this.getCurrentUserId()) {
          this.$message.warning("请先登录");
          this.dialogVisible = false;
        } else {
          this.$message.error("加载购物车失败");
        }
        this.cartItems = [];
      } finally {
        this.loading = false;
      }
    },

    // 加入购物车
    async addToCart(v) {
      try {
        const userId = this.getCurrentUserId();

        if (!userId) {
          this.$message.warning("请先登录");
          return;
        }
        console.log("加入购物车数据", v);

        const payload = {
          userid: userId,
          username: (JSON.parse(localStorage.getItem("USERINFO") || "{}").username) || "",
          productid: v.productInfo?.productId,
          productname: v.productInfo?.name || v.productInfo?.typeItem?.name,
          producttype: v.productInfo?.typeItem?.familyCode || "",
          productcode: v.productInfo?.typeItem?.code || "",
          duration: v.duration || 1,
          durationunion: v.durationunion || "month",
          price: v.totalPrice || 0,
          quantity: v.quantity || 1,
          productVersionType: v.productInfo?.type || "",
          number: v.quantity || 1,
        };

        const res = await setC_cartList(payload);

        if (res.code === 200) {
          this.$message.success("加入购物车");
          // 重新加载购物车列表
          await this.loadCartList();
          await this.refreshCartCount();
        } else {
          this.$message.error(res.msg || "加入购物车失败");
        }
      } catch (err) {
        console.error("加入购物车失败:", err);
        this.$message.error("加入购物车失败");
      }
    },

    // 删除购物车商品
    async removeItem(gIdx, idx) {
      const group = this.groupedCartItems[gIdx];
      const item = group.items[idx];

      this.$set(item, "deleting", true);

      try {
        const res = await batchRemove([item.id]);

        if (res.code === 200) {
          // 从本地列表中移除
          const index = this.cartItems.findIndex((i) => i.id === item.id);
          if (index > -1) {
            this.cartItems.splice(index, 1);
          }
          await this.refreshCartCount();
          // this.$message.success(this.$t("ShoppingCartDialog.deleteSuccess") || "删除成功");
          this.$emit("remove", item);
        } else {
          this.$message.error(res.msg || "删除失败");
        }
      } catch (err) {
        console.error("删除失败:", err);
        this.$message.error("删除失败");
      } finally {
        this.$set(item, "deleting", false);
      }
    },

    // ==================== 数量操作 ====================

    async decreaseQty(item) {
      const currentNumber = Number(item.number) || 1;
      if (currentNumber > 1) {
        this.$set(item, "number", currentNumber - 1);
        await this.updateCartItem(item);
      }
    },

    async increaseQty(item) {
      const currentNumber = Number(item.number) || 0;
      this.$set(item, "number", currentNumber + 1);
      await this.updateCartItem(item);
    },

    // 更新购物车商品（数量变化时）
    async updateCartItem(item) {
      try {
        // 使用同一个接口更新
        await updataList(item.id, item);
        await this.refreshCartCount();
      } catch (err) {
        console.error("更新购物车失败:", err);
      }
    },

    // ==================== 分组选择 ====================

    async refreshCartCount() {
      const userId = this.getCurrentUserId();
      if (!userId) {
        this.$store.commit("user/SET_CARTLISTCOUNT", 0);
        return;
      }
      await this.$store.dispatch("user/getCartListCount", { userid: userId });
    },

    toggleGroupCheck(gIdx) {
      const group = this.groupedCartItems[gIdx];
      group.items.forEach((i) => {
        i.checked = group.checked;
      });
    },

    updateGroupCheck(gIdx) {
      const group = this.groupedCartItems[gIdx];
      group.checked = group.items.every((i) => i.checked);
    },

    // ==================== 结算 ====================

    handleSettle() {
      if (this.selectedItems.length === 0) return;
      // console.log("结算项", this.selectedItems, "总价", this.totalPrice);
      // return;
      const payload = this.selectedItems.map((i) => ({
        ...i,
        productInfo: i.pvData,
      }));
      this.$emit("settle", payload);
    },

    handleClose() {
      this.$emit("close");
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep .cart-dialog {
  border-radius: 12px;
  .el-dialog__body {
    padding: 0;
  }
}
.cart-content {
  display: flex;
  min-height: 400px;
  pointer-events: all;
}
.cart-left {
  flex: 1;
  padding: 20px;
  border-right: 1px solid #f0f0f0;
  max-height: 500px;
  overflow-y: auto;
}
.cart-group {
  margin-bottom: 16px;
  .group-header {
    padding: 12px 0;
    border-bottom: 1px solid #f0f0f0;
    font-weight: 600;
  }
}
.cart-item {
  display: flex;
  align-items: center;
  padding: 16px 0;
  border-bottom: 1px solid #f5f5f5;
  gap: 12px;
  .item-icon {
    width: 40px;
    height: 40px;
    border-radius: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #fff;
    font-weight: 700;
    font-size: 14px;
    img {
      width: 100%;
    }
  }
  .item-info {
    flex: 1;
    .item-name {
      font-size: 14px;
      color: #333;
    }
  }
  .item-duration {
    font-size: 12px;
    color: #999;
    width: 100px;
  }
  .item-price {
    font-size: 14px;
    color: #ff5100;
    font-weight: 600;
    width: 80px;
  }
  .item-quantity {
    display: flex;
    align-items: center;
    gap: 8px;
    span {
      min-width: 20px;
      text-align: center;
    }
  }
  .delete-btn {
    color: #999;
    &:hover {
      color: #ff5100;
    }
  }
}
.empty-cart {
  text-align: center;
  padding: 60px 0;
  img {
    width: 120px;
    opacity: 0.5;
  }
  p {
    color: #999;
    margin-top: 16px;
  }
}
.cart-right {
  width: 240px;
  padding: 20px;
  background: #fafbfc;
}
.settle-card {
  h3 {
    font-size: 16px;
    margin: 0 0 16px;
  }
  .selected-icons {
    margin-bottom: 20px;
    span {
      font-size: 13px;
      color: #999;
    }
    .icons {
      display: flex;
      gap: 8px;
      margin-top: 12px;
      .mini-icon {
        width: 40px;
        height: 40px;
        border-radius: 8px;
        display: flex;
        align-items: center;
        justify-content: center;
        color: #fff;
        font-weight: 700;
        font-size: 12px;
        img {
          width: 100%;
        }
      }
    }
  }
  .empty-selected {
    text-align: center;
    padding: 30px 0;
    img {
      width: 80px;
      opacity: 0.3;
    }
  }
  .total-row {
    display: flex;
    justify-content: space-between;
    padding: 16px 0;
    border-top: 1px solid #e5e5e5;
    .total-price {
      font-size: 18px;
      color: #ff5100;
      font-weight: 600;
    }
  }
  .settle-btn {
    width: 100%;
    height: 44px;
    border-radius: 22px;
    font-size: 15px;
  }
}
</style>
